import { render, staticRenderFns } from "./SitesStatement.vue?vue&type=template&id=2edc5118&scoped=true"
import script from "./SitesStatement.vue?vue&type=script&lang=js"
export * from "./SitesStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc5118",
  null
  
)

export default component.exports